import React, { useState, createContext } from 'react';

export const TermsContext = createContext();

export const TermsProvider = (props) => {
  const [termDocs, setTermDocs] = useState([]);
  return (
    <TermsContext.Provider value={[termDocs, setTermDocs]}>{props.children}</TermsContext.Provider>
  );
};
